import React from 'react'
import { makeStyles } from '@material-ui/core'
import { INSURANCE_TYPES } from 'src/utils/constants/MyPoliciesData'
import { Grid } from '@mui/material'
import { useHistory } from 'react-router-dom'
import { INSURANCE_POLICIES_LIST } from 'src/utils/constants/common'
import { useDispatch } from 'react-redux'
import { updateBuyPolicyTitle } from 'src/actions'

const BuyPolicyTab = () => {
  const classes = useStyles()
  const history = useHistory()
  const dispatch = useDispatch()

  const handleClick = (insurance, url) => {
    if (insurance === INSURANCE_POLICIES_LIST?.LIFE_INSURANCE) {
      dispatch(updateBuyPolicyTitle(INSURANCE_POLICIES_LIST?.LIFE_INSURANCE))
    }
    history.push(`/individual/dashboard/buyPolicy/${url}`)
  }

  return (
    <div className={classes.mainContainer}>
      <div className={classes.insuranceContainer}>
        {INSURANCE_TYPES?.length ? (
          <Grid
            container
            spacing={2}
            columns={12}
            className={classes.gridContainer}
          >
            {INSURANCE_TYPES?.map(
              (insurance) =>
                !insurance.isDisabled && (
                  <Grid
                    item
                    xs={8}
                    sm={6}
                    md={4}
                    lg={3}
                    xl={2.3}
                    key={`policyDetails_${insurance?.policyType}`}
                    className={
                      insurance.isDisabled ? classes.gridBlur : classes.grid
                    }
                  >
                    {!insurance.isDisabled && (
                      <div
                        key={`insurance_${insurance?.insuranceName}`}
                        className={classes.insuranceContent}
                      >
                        <img
                          src={insurance?.logo}
                          alt={`${insurance?.insuranceName} logo`}
                        />
                        <div className={classes.insuranceDetails}>
                          <span
                            className={classes.nameText}
                            onClick={() =>
                              handleClick(
                                insurance?.insuranceName,
                                insurance?.redirectionUrl
                              )
                            }
                          >
                            {insurance?.insuranceName}
                          </span>
                        </div>
                      </div>
                    )}
                  </Grid>
                )
            )}
          </Grid>
        ) : (
          <></>
        )}
      </div>
    </div>
  )
}

export default BuyPolicyTab
const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  insuranceContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    borderRadius: '10px',
    marginTop: '20px',
  },
  gridContainer: {
    padding: '20px 40px',
    gap: '20px',
    justifyContent: 'center',
    marginTop: '20px',
    alignItems: 'stretch',
  },
  grid: {
    padding: '10px',
    paddingTop: '15px',
    border: '1px solid #E4E4E4',
    borderRadius: '10px',
    background: 'linear-gradient(180deg, #E4E4E4 0%, #FFFFFF 100%)',
    justifyContent: 'center',
  },
  gridBlur: {
    padding: '10px',
    paddingTop: '15px',
    border: '1px solid #E4E4E4',
    borderRadius: '10px',
    background: 'linear-gradient(180deg, #E4E4E4 0%, #FFFFFF 100%)',
    justifyContent: 'center',
    opacity: '0.4',
  },
  insuranceContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '7px',
    padding: '40px 0px',
    paddingBottom: '50px !important',
  },
  insuranceDetails: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  nameText: {
    fontWeight: 'bold',
    fontSize: '15px',
    color: '#ffffff',
    justifyContent: 'center',
    textAlign: 'center',
    border: '1px solid #B92250',
    width: '80%',
    padding: '7px',
    margin: '10px 10px',
    backgroundColor: '#B92250',
    borderRadius: '10px',
    cursor: 'pointer',
    '&:hover': {
      opacity: '0.75',
    },
  },
  buttonText: {
    fontWeight: 'bold',
    fontSize: '12px',
    color: '#000000',
    justifyContent: 'center',
    textAlign: 'center',
    border: '1px solid #B92250',
    borderRadius: '10px',
    width: '80%',
    padding: '7px',
    opacity: '0.3',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    gap: '10px',
    opacity: '0.4',
  },
})
